import React, { useState } from "react";
import { Button, CircularProgress, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { GetOrderById } from "../../services/UserSubscriptionServices";
import { formatCurrency } from "../../utils/commons";

// Amount isn't on the lead row — fetch it lazily from the order on demand,
// so a page of leads doesn't fire N order requests up front.
const AmountCell = ({ orderId }: { orderId: string | null }): JSX.Element => {
  const { enqueueSnackbar } = useSnackbar();
  const [amount, setAmount] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  if (!orderId) {
    return (
      <Typography variant="body2" color="textSecondary">
        —
      </Typography>
    );
  }

  if (amount !== null) {
    return <Typography variant="body2">{formatCurrency(amount)}</Typography>;
  }

  const load = async () => {
    setLoading(true);
    try {
      const order = await GetOrderById({ orderId });
      setAmount(order.amount);
    } catch {
      enqueueSnackbar("Couldn't load amount", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      size="small"
      variant="text"
      color="inherit"
      disabled={loading}
      onClick={load}
      sx={{ textTransform: "none", minWidth: 56 }}
    >
      {loading ? <CircularProgress size={14} /> : "View"}
    </Button>
  );
};

export default AmountCell;
